import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NovedadesMes } from '../../../../models/novedadesMes';
import { ConfigDataService } from '../../../../services/config-data.service';
import { CodigosNominaService } from '../../../../services/codigosNomina.service';
import { PersonalService } from '../../../../services/personal.service';
import { formatDate } from '@angular/common';
import { MomentSetService } from '../../../../core/services/moment-set.service';

@Component({
  selector: 'app-novedades-mes-detalle',
  templateUrl: './novedades-mes-detalle.component.html',
  styleUrls: ['./novedades-mes-detalle.component.css']
})
export class NovedadesMesDetalleComponent implements OnInit, AfterViewInit {

  monedasList: any;
  codigosNominaList: any;
  unidadesList: any;

  constructor(private configDataSrv: ConfigDataService,
              private codigosNominaService: CodigosNominaService,
              private fb: FormBuilder,
              private personalService: PersonalService,
              private momentService: MomentSetService) { }

  @Input() set novedadMes(novedadRecibida: NovedadesMes)
  {
    this.novedadMesForm = novedadRecibida;
    this.setearForm(novedadRecibida);
  }

  @Input() set enabledForm(condition: boolean)
  {
    this.habilitarForm(condition);
  }

  @Input() MensajeError: string;
  @Input() verDetalle: boolean;
  @Input() disabledEditing: boolean;
  @Input() desdeAnterior: boolean;
  @Input() ingreso: any;
  @Input() anteriorRetroactividad: boolean;
  @Input() grupoLiq: any;
  @Input() novedadesInvalida: boolean;

  form: FormGroup;
  novedadMesForm: NovedadesMes;
  actualizarFormatoInputNumerico = false;
  submitted: boolean;
  tipoCarga: number;
  NominaList: any
  formHabilitado: boolean;
  MensajeRetro = "";

  ngOnInit(): void
  {
    this.tipoCarga = 0;

    this.configDataSrv.getDatosNominas()
      .subscribe(
        data => {
          this.monedasList=data["Monedas"];
          this.unidadesList=data["UnidadesMedidas"];
        },
        error => {
          console.log(error);
        });
    
    this.codigosNominaService.getAll().subscribe(
      codigos => 
      { 
        codigos.forEach((currentValue,index,arr) => {
          currentValue.desde = this.momentService.convertDateServer(currentValue.desde);
          currentValue.hasta = this.momentService.convertDateServer(currentValue.hasta);
        });

        this.NominaList = codigos;
        this.cargaConceptos();
      });
    
    this.configurarValidadores();
    this.setearForm(this.novedadMesForm);
  }

  configurarValidadores(): void
  {
    this.form = this.fb.group({
      id: ['', Validators.required],
      personal: ['', Validators.required],
      fecha: ['', Validators.required],
      codigosNomina: ['', Validators.required],
      motivo: [''],
      cantidad: [''],     
      quincena: [''],
      importe: [''],
      moneda: [''],
      unidadMedida: ['', Validators.required],
    });

  }

  get registerFormControl()
  {
    return this.form.controls;
  }

  setearForm(novedadMes: NovedadesMes)
  {
    if (this.form != undefined)
    {
      this.form.controls['id'].setValue(novedadMes?.id);
      this.form.controls['personal'].setValue(novedadMes?.personal);
      this.form.controls['fecha'].setValue(new Date(novedadMes?.fecha));
      this.form.controls['cantidad'].setValue(novedadMes?.cantidad);
      this.form.controls['motivo'].setValue(novedadMes?.motivo);
      this.form.controls['unidadMedida'].setValue(novedadMes?.unidadMedida);
      this.form.controls['quincena'].setValue(novedadMes?.quincena);
      this.form.controls['codigosNomina'].setValue(novedadMes?.codigosNomina);
      this.form.controls['importe'].setValue(novedadMes?.importe);
      this.form.controls['moneda'].setValue(novedadMes?.moneda);

      if (novedadMes.id == 0)
      {
        this.habilitarForm(true);
      }
      else
      {
        this.habilitarForm(false);
      }
      this.chequeoRetro();
    }
  }

  habilitarForm(habilitado: boolean)
  {
    if (this.form != undefined)
    {
      if (habilitado)
      {
        this.form.enable();
      }
      else
      {
        this.form.disable();
      }
      this.formHabilitado = habilitado;
      this.form.controls['unidadMedida'].disable();
      this.getTipoCargaCodigoNomina(this.novedadMesForm.codigosNomina);
    }
  }

  ngAfterViewInit()
  {
    if (this.form.controls['id'].value != "0")
    {
      this.form.controls['importe'].setValue(this.novedadMesForm?.importe);
      this.actualizarFormatoInputNumerico = true;
    }
  }

  onChangeCodigoNomina(event)
  {
    this.getTipoCargaCodigoNomina(event.value);
    if (this.tipoCarga == 2) 
    {
      this.form.controls['importe'].setValue(0);
      this.form.controls['moneda'].setValue(1);
    } else if (this.tipoCarga == 1)
    {
      this.form.controls['cantidad'].setValue(0);
    } else if (this.tipoCarga == 4)
    {
      this.form.controls['importe'].setValue(0);
      this.form.controls['moneda'].setValue(1);
      this.form.controls['cantidad'].setValue(0);
    }
    let unidadMedida = this.codigosNominaList.find(c => c.id == event.value).um;
    this.form.controls['unidadMedida'].setValue(unidadMedida);
  }

  getTipoCargaCodigoNomina(nomina:number){
    this.tipoCarga = 0;
    if (nomina != null) {
      this.tipoCarga = this.codigosNominaList.find(m => m.id == nomina).tipoCarga;
    }
    if (this.tipoCarga == 2) 
    {
      this.setValidatorRequired('importe', null);
      this.setValidatorRequired('moneda', null);
      this.setValidatorRequired('cantidad', Validators.required);
    } else if (this.tipoCarga == 1)
    {
      this.setValidatorRequired('importe', Validators.required);
      this.setValidatorRequired('moneda', Validators.required);
      this.setValidatorRequired('cantidad', null);
    } else if (this.tipoCarga == 3)
    {
      this.setValidatorRequired('importe', Validators.required);
      this.setValidatorRequired('cantidad', Validators.required);
      this.setValidatorRequired('moneda', Validators.required);
    } else
    {
      this.setValidatorRequired('importe', null);
      this.setValidatorRequired('moneda', null);
      this.setValidatorRequired('cantidad', null);
    }
  }

  setValidatorRequired(campo, requerido) {
    this.form.controls[campo].setValidators(requerido);
    this.form.controls[campo].updateValueAndValidity();
  }

  cargaConceptos()
  {
    //Carga los conceptos validos
    let fecha = this.form.get("fecha").value.toDateString();
    let concepto = this.form.get("codigosNomina").value;

    this.codigosNominaList = this.NominaList && this.NominaList.filter(items => items.novedadesMes == true &&
                                                                                Date.parse(items.desde) <= Date.parse(fecha) &&
                                                                                Date.parse(items.hasta) >= Date.parse(fecha)) ;
    
    let index = this.codigosNominaList.findIndex(x => x.id == concepto)
    if (index == -1)
    {
      //No existe en la nueva lista, lo limpio
      this.form.controls['codigosNomina'].setValue(null);
    }
  }

  onChangeFechas()
  {
    this.cargaConceptos();
    this.chequeoRetro();
  }

  chequeoRetro()
  {
    this.MensajeRetro = "";
    let desde = this.form.get("fecha").value.toDateString();
    
    this.personalService.ChequeoRetroactividad(this.novedadMesForm.personal, 'NovedadesFijas', desde, desde, true).subscribe(
      data =>
      {
        let resul = data;
        if (resul.haceRetro)
        {
          let fecha = formatDate(resul.fechaRetro, 'dd-MM-yyyy', 'en-US');
          this.MensajeRetro = "Esta acción generará Retro a partir del " + fecha.toString();
        }
      }
    );
  }
}

